<div
*ngIf="isVisible"
  @fadeAnimation
class="w-[350px] sm:w-[400px] rounded-lg border shadow px-3 py-2 relative flex justify-end items-start gap-4 select-none overflow-hidden" [ngClass]="{
    'bg-[#F7F7F8] border-gray-200': type() === notificationType.DEFAULT,
    'bg-[#F0FAFF] border-blue-200': type() === notificationType.INFO,
    'bg-[#FFF9EB] border-yellow-200': type() === notificationType.WARNING,
    'bg-[#EEFBF4] border-green-200': type() === notificationType.SUCCESS,
    'bg-[#FEF0F4] border-red-200': type() === notificationType.ERROR
  }">

  <button (click)="emitCloseNotification()" class="absolute top-3 left-3 text-gray-500 hover:text-gray-800 text-sm">
    <i class="bi bi-x-lg cursor-pointer"></i>
  </button>

  <div class="absolute top-0 right-0 w-1.5 h-full"
    [ngClass]="{
      'bg-gray-700': type() === notificationType.DEFAULT,
      'bg-blue-700': type() === notificationType.INFO,
      'bg-yellow-700': type() === notificationType.WARNING,
      'bg-green-700': type() === notificationType.SUCCESS,
      'bg-red-700': type() === notificationType.ERROR
    }"
  ></div>

  <div class="flex flex-col items-end justify-center gap-1">
    <p class="font-semibold text-sm"
      [ngClass]="{
        'text-[#121217]': type() === notificationType.DEFAULT,
        'text-[#0075AD]': type() === notificationType.INFO,
        'text-[#8A6100]': type() === notificationType.WARNING,
        'text-[#17663A]': type() === notificationType.SUCCESS,
        'text-[#D50B3E]': type() === notificationType.ERROR
      }"
    >
      {{ title() }}
    </p>

    <p class="text-xs text-right"
      [ngClass]="{
        'text-[#6C6C89]': type() === notificationType.DEFAULT,
        'text-[#0075AD]': type() === notificationType.INFO,
        'text-[#8A6100]': type() === notificationType.WARNING,
        'text-[#17663A]': type() === notificationType.SUCCESS,
        'text-[#D50B3E]': type() === notificationType.ERROR
      }"
    >
      {{ message() }}
    </p>
  </div>

  <i class="bi bi-info-circle-fill py-0!"
    [ngClass]="{
      'text-gray-700': type() === notificationType.DEFAULT,
      'text-blue-700': type() === notificationType.INFO,
      'text-yellow-700': type() === notificationType.WARNING,
      'text-green-700': type() === notificationType.SUCCESS,
      'text-red-700': type() === notificationType.ERROR
    }"
  ></i>
</div>
